import { motion } from "framer-motion";

import { staggerContainer } from "../utils/motion";

const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export const SectionWrapper = (Component, idName) =>
  function HOC() {
    if (prefersReducedMotion()) {
      return (
        <section id={idName}>
          <Component />
        </section>
      );
    }
    return (
      <motion.section
        id={idName}
        variants={staggerContainer()}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.1 }}
      >
        <Component />
      </motion.section>
    );
  };
